import React, { FunctionComponent } from 'react';
import { isMobileView } from '../utils/utils';
import classes from './GeneralPageLayout.module.css';

interface Props {
  navigationBar?: React.ReactNode;
  elementCentr?: React.ReactNode;
  elementPult?: React.ReactNode;
}

export const GeneralPageLayout: FunctionComponent<Props> = ({
  navigationBar,
  elementCentr,
  elementPult,
}) => (
  <div
    style={{ userSelect: 'none' }}
    className={!isMobileView() ? classes.myDiv : classes.myDivSiteStub}
  >
    <div
      style={{
        position: 'fixed',
        top: '205px',
      }}
    >
      {elementPult}
    </div>
    {!isMobileView() && (
      <div className={classes.container}>
        <div className={classes.elementBar}>{navigationBar}</div>
        <div className={classes.elementCentr}>{elementCentr}</div>
      </div>
    )}
  </div>
);

GeneralPageLayout.defaultProps = {
  navigationBar: undefined,
  elementCentr: undefined,
  elementPult: undefined,
};
